import SignaturePanel from './SignaturePanel';
import Spinner from './Spinner';
import {
  renderPermissionStatus,
  renderVerificationStatus,
} from './WidgetInfo';

export default SignaturePanel;

export {
  renderPermissionStatus,
  renderVerificationStatus,
  SignaturePanel,
  Spinner,
};
